import React from "react";

// Package Import

import { Typography, Box, useTheme, Grid, Paper, Chip } from "@mui/material";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@mui/styles";

// User Import

import {
  GlobeBlueIcon,
  ProfileIcon,
  PopulationServedIcon,
  InventoryIcon,
  HashIcon,
  UnitsDeliveredIcon,
  ExpiredDosesIcon,
  WastedDosesIcon,
  DomainIcon,
  EmailIcon,
  TempratureIcon,
  BatchIcon1,
} from "../../../../Svg";
import Barchart from "../Barchart";
import { format } from "date-fns";

// Component

const PouDetails = () => {
  // Hooks

  const theme = useTheme();
  const { state } = useLocation();

  const useStyles = makeStyles({
    chipStyle: {
      color: "blue",
      borderRadius: 1,
      maxWidth: 100,
      width: 100,
    },
    typographystyle: {
      marginLeft: 16,
    },
  });
  const classes = useStyles();

  // Render

  return (
    <Box>
      <Grid container spacing={2} sx={{overflow:{xs:"hidden",sm:"hidden",md:"hidden",lg:"hidden"}}}>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          <Paper>
            <Box padding={{ xs: 1, sm: 2 }}>
              <Typography variant="h6" component="div">
                General information
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {state?.node?.name}
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <GlobeBlueIcon />
                  </Box>
                  <Typography
                    className={classes.typographystyle}
                    sx={{ paddingTop: 1.8, textAlign: "left" }}
                  >
                    Hospital
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.name}
                  />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <ProfileIcon />
                  </Box>
                  <Typography
                    className={classes.typographystyle}
                    sx={{ paddingTop: 1.8 }}
                  >
                    Population
                  </Typography>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.population}
                  />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <PopulationServedIcon />
                  </Box>
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Population Served
                    </Typography>

                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated at{" "}
                      {state?.node?.updated_at
                        ? format(new Date(), "dd-MM-yyyy")
                        : ""}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.vaccinated || "N/A"}
                  />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <InventoryIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Current Inventory
                    </Typography>
                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip className={classes.chipStyle} label="1000 Units" />
                </Box>
              </Grid>
            </Box>
          </Paper>

          <Grid item mt={2}>
            <Paper>
              <Box padding={{ xs: 1, sm: 2 }}>
                <Typography variant="h5">Monthly Overview</Typography>
                <Typography variant="p" color={"text.grayText"}>
                  Population Served per month
                </Typography>
                <Barchart />
                <Typography variant="body2" textAlign={"center"}>
                  Year-2022
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
          {/* <Grid container padding={2}> */}
          <Paper>
            <Box
              padding={{ xs: 1, sm: 2 }}
              // minWidth={{ xs: 300, sm: 780, lg: "400px" }}
            >
              <Typography variant="h6" component="div">
                Inventory information
              </Typography>
              <Typography sx={{ mb: 1.5 }} color="text.secondary">
                {state?.node?.name}
              </Typography>
              {/* 1 ROW */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <HashIcon />
                  </Box>
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Vaccine Batch
                    </Typography>

                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Current
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.reference_number || 0}
                  />
                </Box>
              </Grid>
              {/* 2nd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <BatchIcon1 />
                  </Box>
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Batch Recieved
                    </Typography>

                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Current Batch
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={
                      state?.node?.received_date
                        ? format(
                            new Date(state?.node?.received_date),
                            "MM/dd/yyyy"
                          )
                        : "MM/dd/yyyy"
                    }
                  />
                </Box>
              </Grid>
              {/* 3rd Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <BatchIcon1 />
                  </Box>
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Batch Expiry
                    </Typography>

                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Current Batch
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={
                      state?.node?.expiry_date
                        ? format(
                            new Date(state?.node?.expiry_date),
                            "MM/dd/yyyy"
                          )
                        : "MM/dd/yyyy"
                    }
                  />
                </Box>
              </Grid>
              {/* 4th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <TempratureIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Storage Temprature
                    </Typography>
                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.storage_temperature || "N/A"}
                  />
                </Box>
              </Grid>
              {/* 5th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <UnitsDeliveredIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Units Delivered
                    </Typography>
                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.quantity_dispatch}
                  />
                </Box>
              </Grid>
              {/* 6th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <ExpiredDosesIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Expired Doses
                    </Typography>
                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.quantity_expired || 0}
                  />
                </Box>
              </Grid>
              {/* 7th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <WastedDosesIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Wasted Dos
                    </Typography>
                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    >
                      Updated 30 Minutes ago
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.quantity_damage || 0}
                  />
                </Box>
              </Grid>
              {/* 8th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <EmailIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Email
                    </Typography>
                    <Typography
                      className={classes.typographystyle}
                      color="text.secondary"
                      sx={{ fontSize: "12px" }}
                    ></Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.email || "N/A"}
                  />
                </Box>
              </Grid>
              {/* 9th Row */}
              <Grid
                container
                display={"flex"}
                justifyContent={"space-between"}
                sx={{ mb: 1.5 }}
              >
                <Box display={"flex"} alignItems={"center"}>
                  <Box
                    height={"60px"}
                    width={"60px"}
                    display={"flex"}
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      backgroundColor: `${theme.palette.secondary.dark}`,
                      borderRadius: 1.5,
                    }}
                  >
                    <DomainIcon />
                  </Box>{" "}
                  <Box>
                    <Typography
                      className={classes.typographystyle}
                      variant="body1"
                      component="div"
                      sx={{ paddingTop: 1 }}
                    >
                      Domain
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ paddingTop: 1.2 }}>
                  <Chip
                    className={classes.chipStyle}
                    label={state?.node?.domain || "N/A"}
                  />
                </Box>
              </Grid>
            </Box>
          </Paper>
          {/* </Grid> */}
        </Grid>
      </Grid>
    </Box>
  );
};

export default PouDetails;
